import { TextField } from '@material-ui/core';
import React from 'react';
import SearchButton from '../../common/searchButton';

const SearchBox = ({ onHandleChangeSearch, onHandleSearch, value }) => {
  return (
    <>
      <TextField
        fullWidth
        id='search'
        label='Cédula o correo ESPOCH'
        margin='normal'
        name='search'
        onChange={onHandleChangeSearch}
        placeholder='Ingrese una cédula(sin guión) o un correo espoch'
        required={true}
        size='small'
        value={value}
        variant='outlined'
      />
      <SearchButton
        onSearch={onHandleSearch}
        disabled={value.length <= 5 ? true : false}
      />
    </>
  );
};

export default SearchBox;
